import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FinalCTASection = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-8 sm:py-14 bg-[#0B1F3B] relative overflow-hidden" ref={ref}>
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#D4A520]/5 blur-3xl" />
        <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-[#D4A520]/5 blur-2xl" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-[#D4A520]/5 blur-2xl" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <div className={`transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 bg-[#D4A520]/15 border border-[#D4A520]/30 rounded-full px-4 py-1.5 mb-6 sm:mb-8">
            <span className="text-[#D4A520] text-xs font-semibold tracking-widest uppercase">Start Today</span>
          </div>

          <h2
            className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#D4A520] mb-4 sm:mb-6 leading-tight"
            style={{ fontFamily: 'Cormorant Garamond, serif' }}
          >
            Ready to Invest
            <span className="block text-white">in Yourself?</span>
          </h2>

          <p className="text-white text-base sm:text-xl mb-6 sm:mb-8 max-w-xl mx-auto">
            Join thousands of women building wealth together. Your financial future starts now.
          </p>

          <div className="flex flex-col items-center gap-4">
            {/* Primary gold CTA */}
            <button
              onClick={() => navigate('/onboarding-authentication')}
              className="relative w-full sm:w-auto px-12 py-4 text-[#0B1F3B] font-bold text-lg rounded-xl overflow-hidden"
              style={{
                background: '#D4A520',
                transition: 'transform 250ms ease-out, box-shadow 250ms ease-out, background 250ms ease-out',
                boxShadow: '0 8px 32px rgba(212,165,32,0.3)',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.04)';
                e.currentTarget.style.background = '#E8C040';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(212,165,32,0.5)';
                const shine = e?.currentTarget?.querySelector('.btn-shine');
                if (shine) { shine.style.transform = 'translateX(100%)'; shine.style.transition = 'transform 500ms ease'; }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.background = '#D4A520';
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(212,165,32,0.3)';
                const shine = e?.currentTarget?.querySelector('.btn-shine');
                if (shine) { shine.style.transform = 'translateX(-100%)'; shine.style.transition = 'none'; }
              }}
              onMouseDown={(e) => { e.currentTarget.style.transform = 'scale(0.97)'; }}
              onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1.04)'; }}
            >
              <span className="btn-shine absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.4) 50%, transparent 60%)', transform: 'translateX(-100%)' }} />
              <span className="relative z-10">Start Your WIN Journey</span>
            </button>
            {/* Sign In ghost link with underline draw */}
            <button
              onClick={() => navigate('/onboarding-authentication')}
              className="text-white text-sm transition-colors duration-200"
              style={{ cursor: 'pointer', background: 'none', border: 'none' }}
            >
              Already a member?{' '}
              <span
                className="relative inline-block"
                style={{ color: '#D4A520' }}
                onMouseEnter={(e) => {
                  const line = e?.currentTarget?.querySelector('.underline-draw');
                  if (line) line.style.width = '100%';
                }}
                onMouseLeave={(e) => {
                  const line = e?.currentTarget?.querySelector('.underline-draw');
                  if (line) line.style.width = '0%';
                }}
              >
                Sign In
                <span
                  className="underline-draw absolute bottom-0 left-0 h-px bg-[#D4A520]"
                  style={{ width: '0%', transition: 'width 250ms ease-out' }}
                />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
